export default "__VITE_ASSET__BQVvYReG__"